import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { supplementaryMaterialSnoozed } from "store/actions/supplementaryMaterialActions";
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
import { SupplementaryMaterialTodoMoreActionProps } from "models/propTypes/supplementaryMaterialPropTypes";
import { AuthEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { MoreActions, useSnoozeAction } from "components/common";
import { useInvoiceDownload } from "components/invoice";
import { useReceiptDownload } from "components/receipt";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance } from "utils/helpers";

const SupplementaryMaterialTodoMoreActions: React.FC<SupplementaryMaterialTodoMoreActionProps> = (props) => {
  const { supplementaryMaterial, markAsDoneHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  //#region snooze
  const onSnoozeSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(supplementaryMaterialSnoozed(supplementaryMaterial.id));
  };

  const { snoozeAction } = useSnoozeAction(
    props.supplementaryMaterial.id,
    ApiModel.TodoType.SupplementaryMaterial,
    onSnoozeSuccess
  );
  //#endregion

  //#region download
  const sourceId = props.supplementaryMaterial.sourceId;

  const invoiceDownloadAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.Download
    )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.IncomingInvoice)}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: useInvoiceDownload(sourceId),
  };

  const receiptDownloadAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.Download
    )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.Receipt)}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: useReceiptDownload(sourceId),
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);

    if (!isAuditor) {
      actions.push(snoozeAction);
    }
    if (props.supplementaryMaterial.sourceType === ApiModel.SupplementaryMaterialSourceType.IncomingInvoice)
      actions.push(invoiceDownloadAction);
    else if (props.supplementaryMaterial.sourceType === ApiModel.SupplementaryMaterialSourceType.CustomerReceipt) {
      actions.push(receiptDownloadAction);
    }

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default SupplementaryMaterialTodoMoreActions;
